module.exports = __webpack_public_path__ + "static/banner-texture-ef1fa3ea6b86324ad7d964a340f7569d.png";